import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { eDotXetHocVuPhamViSinhVienActionIds, IDotXetHocVuPhamViSinhVienActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuPhamViSinhVienActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { dotXetHocVuPhamViSinhVienApi } from "../../../api/xet-hoc-vu/dotXetHocVuPhamViSinhVienApi";
import { IStrIdsRequest } from "../../../model/request/IStrIdsRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";

export function* dotXetHocVuPhamViSinhVienSaga(): any {
    yield takeLatest(eDotXetHocVuPhamViSinhVienActionIds.LOAD_BY_HOC_KY_NAM_HOC_START, loadByHocKyNamHocWoker);
    yield takeEvery(eDotXetHocVuPhamViSinhVienActionIds.INSERTS_START, insertsWorker);
    yield takeEvery(eDotXetHocVuPhamViSinhVienActionIds.DELETES_START, deletesWorker);
}


function* loadByHocKyNamHocWoker(action: IDotXetHocVuPhamViSinhVienActionTypes): any {
    const request = action.payload as { hoc_ky: number, nam_hoc: string };
    const response: IBaseResponse = yield dotXetHocVuPhamViSinhVienApi.SelectByHocKyNamHoc(request.hoc_ky, request.nam_hoc);
    if (response.is_success) {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.LOAD_BY_HOC_KY_NAM_HOC_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.LOAD_BY_HOC_KY_NAM_HOC_ERROR(response.message ?? "Lỗi khi tải phạm vi đợt xét học vụ"));
    }
}

function* insertsWorker(action: IDotXetHocVuPhamViSinhVienActionTypes): any {
    const request = action.payload as { id_dot_xet: number, request: IStrIdsRequest };
    const response: IBaseResponse = yield dotXetHocVuPhamViSinhVienApi.Inserts(request.id_dot_xet, request.request);
    if (response.is_success) {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.INSERTS_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.INSERTS_ERROR(response.message ?? "Lỗi khi thêm phạm vi đợt xét học vụ"));
    }
}

function* deletesWorker(action: IDotXetHocVuPhamViSinhVienActionTypes): any {
    const request = action.payload as { request: IIdsRequest };
    const response: IBaseResponse = yield dotXetHocVuPhamViSinhVienApi.Deletes(request.request);
    if (response.is_success) {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.DELETES_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetHocVu.dotXetHocVuPhamViSinhVien.DELETES_ERROR(response.message ?? "Lỗi khi xóa phạm vi đợt xét học vụ"));
    }
}